import { useQuery } from '@tanstack/react-query'
import { tenantsApi } from '../api'

export function useTenantDetail(tenantId: string | undefined) {
  return useQuery({
    queryKey: ['tenant', tenantId],
    queryFn: async () => {
      if (!tenantId) throw new Error('Tenant ID is required')
      const response = await tenantsApi.get(tenantId)
      return response.data.data
    },
    enabled: !!tenantId,
  })
}
